/*
 Плагин для определения хоста приложения, с дальнейшим прокидыванием в nuxt
 Нужен для удобного доступа к хосту приложения в pageMeta и middleware
*/
export default defineNuxtPlugin({
  name: 'initHost',
  setup({ ssrContext }) {
    let host: string

    if (import.meta.server) {
      const ssrHost = ssrContext?.event?.node?.req?.headers?.host || ''

      if (!ssrHost) createError({ statusCode: 500 })

      host = ssrHost
    } else {
      host = window.location.host
    }

    return {
      provide: {
        host,
      },
    }
  },
})
